enum CHElementScale {
  Building = "building",
  Object = "object",
}

export default CHElementScale;
